import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import cityIbgeCensusReadAction from './cityIbgeCensusRead.action.json' with { type: 'json' }

const cnaeReadDefinition = defineReadAutoAction(cityIbgeCensusReadAction, 'cityIbgeCensus')

export default cnaeReadDefinition
